module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-10.1a6ed3d.woff2";